import { Button, NI360Icon } from '@native-instruments/webex-ni';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import env from '~/env';
import { useIntl } from '~/helpers/intl';

// The color is hardcoded because it's a color just for this banner, not related to the design system.
// Some other hardcoded adjustment has to be made because of this.
export const BannerDealSOS = () => {
  const { t } = useIntl();
  const { language } = useParams<{ language: string }>();

  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const hasClosed =
      window.sessionStorage.getItem('niBannerClosed') === 'true';

    setShouldDisplay(!hasClosed);
  }, []);

  const onClose = () => {
    window.sessionStorage.setItem('niBannerClosed', 'true');
    setShouldDisplay(false);
  };

  if (!shouldDisplay) return null;

  return (
    <div
      id="ni-2-banner-sos"
      className="min-h-[56px] relative flex flex-col md:flex-row p-2 md:px-3 md:py-0 justify-center items-center w-full text-center"
      style={{
        backgroundImage:
          'linear-gradient(to right, #ff785f 0, #d36b98 25%, #9d5cdd 50%, #4f79b2 75%, #009687 100%)',
      }}
    >
      <NI360Icon />
      <span className="text-xs text-white font-bold pl-3">
        {t('TopBanner360', {
          fallback:
            'Unlock an ever-growing collection of instruments, sounds, and effects.',
        })}
      </span>
      <a
        className="text-xs mt-1 md:mt-0 ml-2 webex-btn webex-btn--primary text-grey-90 bg-white hover:bg-white font-bold px-1.5 py-[6px]"
        href={`${env.APP_BASE_URL}/${language}/products/subscription/360-subscription/`}
      >
        {t('TopBanner360CTA', {
          fallback: 'Try it free',
        })}
      </a>
      <Button
        onClick={onClose}
        variant="ghost"
        className="absolute top-50% right-2 text-2xl cursor-pointer text-white font-bold"
      >
        ×
      </Button>
    </div>
  );
};
